import axiosConfig from "./axiosConfig";

export interface SiteArtifact {
  guid: string;
  uploadedAt: number;
  filename: string;
  user?: string;
  notes?: string;
}

export interface SiteArtifactsResponse {
  artifacts: SiteArtifact[];
}

const getSiteArtifacts = async (
  authToken: string,
  siteId: string
): Promise<SiteArtifactsResponse> => {
  const { data } = await axiosConfig.get(`/site/${siteId}/artifacts`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getSiteArtifacts;
